import { useTranslation } from 'react-i18next';

import { Button, generateQeId, Input, ControlGroup } from '@ctct/ui-react';

import { useDiscountCodeContext } from '../DiscountCodeContext';

const inputId = 'discount-code-input-id';

const DiscountCodeInput = () => {
  const { t } = useTranslation();
  const { qeId, discountCode, loading, formattedError, handleChange, handleApply } = useDiscountCodeContext();

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <ControlGroup full className="discount-code-container__input-container">
        <Input
          autoFocus
          id={inputId}
          invalid={!!formattedError}
          data-qe-id={generateQeId(qeId, 'discount-input')}
          className="discount-code-container__input-container_input"
          placeholder={t('order_summary.discount-code.input-code-placeholder')}
          value={discountCode}
          onChange={handleChange}
        />
        <Button
          type="submit"
          data-qe-id={generateQeId(qeId, 'discount-apply-button')}
          className="discount-code-container__input-container_button"
          kind="plain"
          text={t('order_summary.discount-code.apply-button-text')}
          disabled={loading || discountCode.length === 0}
          busy={loading}
          onClick={handleApply}
        />
      </ControlGroup>

      {formattedError && (
        <label htmlFor={inputId} className="error-msg">
          {formattedError}
        </label>
      )}
    </form>
  );
};

export default DiscountCodeInput;
